customElements.get("dbtfy-cart-discount") ||
customElements.define("dbtfy-cart-discount", class extends HTMLElement {

  constructor() {
    super();

    console.log("DBTFY Discount: initialized");

    this.data = Debutify.widgets["dbtfy-cart-discount"];

    const icon = this.querySelector(".delivery-label-icon i");
    if (icon) {
      icon.setAttribute("data-icon", this.data.dbtfy_cart_discount_label_icon);
    }

    this.discountSummaryLabel = this.querySelector(".dbtfy-cart-discount-show");
    this.discountStatus = this.querySelector(".discount-status");
    this.button = this.querySelector(".dbtfy-cart-discount__button");

    this.discountCode = "";
    this.fetch = false;

    this.setup();
  }

  setup() {
    this.init();
    this.fetchCart("");
  }

  init() {

    if (!this.button) {
      console.warn("DBTFY Discount: button not found");
      return;
    }

    this.button.onclick = () => {

      const code = this.querySelector("input").value.trim();

      console.log("DBTFY Discount: entered code =", code);

      if (!code) return;

      this.discountCode = code;
      this.fetch = true;

      this.applyDiscount(code);
    };
  }

  applyDiscount(code) {

    console.log("DBTFY Discount: applying", code);

    fetch(`/discount/${code}`, {
      method: "GET",
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
    .then(res => {

      console.log("DBTFY Discount: response status", res.status);

      localStorage.setItem("dbtfy-cart-discount", code);

      if (this.discountStatus) {
      }

      /* refresh cart after applying code */

      setTimeout(() => {
        this.fetchCart(code);
      }, 0);

    })
    .catch(err => {
      console.error("DBTFY Discount error", err);

      if (this.discountStatus) {
        this.discountStatus.classList.remove("hidden");
        this.discountStatus.textContent = " Invalid";
      }
    });
  }

  fetchCart(code) {

    console.log("DBTFY Discount: fetching cart");

    fetch(`${window.routes.cart_url}.js`)
      .then(r => r.json())
      .then(cart => {

        console.log("DBTFY Discount: cart", cart);

        let hasDiscount = false;
        let discountTitle = "";

        /* ITEM DISCOUNTS */

        cart.items.forEach(item => {

          if (item.discounts && item.discounts.length > 0) {
            hasDiscount = true;
            discountTitle = item.discounts[0].title;
          }

        });

        /* CART LEVEL DISCOUNTS */

        if (
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0
        ) {

          hasDiscount = true;
          discountTitle = cart.cart_level_discount_applications[0].title;

        }

        console.log("DBTFY Discount: hasDiscount =", hasDiscount);

        if (this.discountSummaryLabel && discountTitle) {
          this.discountSummaryLabel.textContent = discountTitle;
        }

        /* UPDATE INPUT */

        document
          .querySelectorAll('.dbtfy-cart-discount__container input[type="text"]')
          .forEach(input => {
            input.value = discountTitle || code;
          });

        /* STATUS BADGE */
        if (localStorage.getItem("dbtfy-cart-discount")) {

            this.discountStatus.classList.remove("hidden");

            if (hasDiscount) {

                /* normal product/cart discount */
                this.discountStatus.textContent = " Appliqué";

            } else if (this.fetch) {

                /* likely free shipping discount */
                this.discountStatus.textContent = " Livraison offerte";

            } else {

                this.discountStatus.textContent = " Invalide";

            }

            setTimeout(() => {
                localStorage.removeItem("dbtfy-cart-discount");
            }, 500);
        }

      })
      .catch(err => {
        console.error("DBTFY Discount: cart fetch error", err);
      });
  }

});